var fuelDispenserUpdateList = (function () {
  const init = function () {
    $("#SelectedFirmwareIdValidation").hide();
    $("#fuel-dispensers-update-datatable thead tr")
      .clone(true)
      .addClass("filters")
      .appendTo("#fuel-dispensers-update-datatable thead");
    $.fn.dataTableExt.oSort["version-desc"] = function (x, y) {
      const x_version = $(x).text().split(".");
      const y_version = $(y).text().split(".");
      if (x_version.length != 3 ) {
        return 1;
      }
      if (y_version.length != 3 ) {
        return -1;
      }
      if (parseInt(x_version[0]) > parseInt(y_version[0])) {
        return -1;
      }
      if (parseInt(x_version[1]) > parseInt(y_version[1])) {
        return -1;
      }
      if (parseInt(x_version[2]) > parseInt(y_version[2])) {
        return -1;
      }
      return 1;
    };
    $.fn.dataTableExt.oSort["version-asc"] = function (x, y) {
      const x_version = $(x).text().split(".");
      const y_version = $(y).text().split(".");
      if (x_version.length != 3 ) {
        return 1;
      }
      if (y_version.length != 3 ) {
        return -1;
      }
      if (parseInt(x_version[0]) > parseInt(y_version[0])) {
        return 1;
      }
      if (parseInt(x_version[1]) > parseInt(y_version[1])) {
        return 1;
      }
      if (parseInt(x_version[2]) > parseInt(y_version[2])) {
        return 1;
      }
      return -1;
    };
    var table = $("#fuel-dispensers-update-datatable").DataTable({
      autoWidth: false,
      stateSave: true,
      responsive: true,
      order: [],
      orderCellsTop: true,
      columnDefs: [
        { className: "fuel-dispenser-model-column", targets: 0 },
        { className: "serial-number-column", targets: 1 },
        { className: "client-column", targets: 2 },
        { type: "version", className: "hardware-column", targets: 3 },
        { type: "version", className: "bootloader-column", targets: 4 },
        { type: "version", className: "firmware-column", targets: 5 },
        { type: "version", className: "available-firmware-column", targets: 6 },
        { type: "version", className: "available-update-column", targets: 7 },
        { className: "fuel-dispenser-actions-column desktop", targets: 8 },
        { orderable: false, targets: 8 },
      ],
      language: {
        url: "https://cdn.datatables.net/plug-ins/1.10.19/i18n/Ukrainian.json",
        //TODO: make it depends on current culture not on sdn call
      },
      select: {
        style: "multi",
        className: "selected-datatable-row",
      },
      initComplete: function () {
        var api = this.api();
        // For each column
        api
          .columns()
          .eq(0)
          .each(function (colIdx) {
            // Set the header cell to contain the input element
            var cell = $(".filters th").eq(
              $(api.column(colIdx).header()).index()
            );
            var title = $(cell).text();
            $(cell).html("");
            if ([1, 2, 3, 4, 5, 6, 7].includes(colIdx)) {
              $(cell).html(
                '<input type="text" style="width:100%;" placeholder="' +
                  title.trim() +
                  '" />'
              );
              if ([3, 4, 5].includes(colIdx)) {
                /*$(
                  "input",
                  $(".filters th").eq($(api.column(colIdx).header()).index())
                ).inputmask("9.9.9");*/
              }
            }

            // On every keypress in this input
            $(
              "input",
              $(".filters th").eq($(api.column(colIdx).header()).index())
            )
              .off("keyup change")
              .on("keyup change", function (e) {
                e.stopPropagation();

                // Get the search value
                $(this).attr("title", $(this).val());
                var regexr = "({search})"; //$(this).parents('th').find('select').val();

                var cursorPosition = this.selectionStart;
                // Search the column for that value
                api
                  .column(colIdx)
                  .search(
                    this.value != ""
                      ? regexr.replace("{search}", "(((" + this.value + ")))")
                      : "",
                    this.value != "",
                    this.value == ""
                  )
                  .draw();

                $(this)
                  .focus()[0]
                  .setSelectionRange(cursorPosition, cursorPosition);
              });
          });
      },
    });


    $("#fuel-dispensers-update-datatable").on("click", ".mdi-close-outline", function () {
      const id = $(this).data("fuel-dispenser-id");
      const serial = $(this).data("fuel-dispenser-serial");
      $("#fuel-dispenser-to-clear").text(serial);
      $("#clear-update-firmware-button").attr("data-fuel-dispenser-id", id);
    });

    $("#clear-update-firmware-button").on("click", function () {
      const fuelDispenserIdToClear = $(this).data("fuel-dispenser-id");
      sendClearRequest(fuelDispenserIdToClear);
    });

    function sendClearRequest(id) {
      $.ajax({
        url: `/FirmwareUpdates/Clear/${id}`,
        method: "DELETE",
        contentType: "application/json",
      }).done(function (data) {
        $("#clear-update-modal").modal("hide");
        $.showNotification(data.header, data.message, data.success);
      });
    }

    $(".firmware-dropdown").change(function () {
      $("#SelectedFirmwareIdValidation").hide();
    });

    $("#fuel-dispensers-update-datatable").on(
      "click",
      ".mdi-cloud-search",
      function () {
        const id = $(this).data("fuel-dispenser-id");
        $("#update-firmware-button").attr("data-fuel-dispenser-id", id);
      }
    );

    $("#update-filtered").on("click", function () {
      $("#update-firmware-button").attr("data-fuel-dispenser-id", 0);
    });

    $("#fuel-dispensers-update-datatable").on(
      "click",
      ".mdi-cloud-sync",
      function () {
        var firmwareFuelDispensers = new Array();
        const id = $(this).data("fuel-dispenser-id");
        const firmwareId = $(this).data("available-update-id");
        firmwareFuelDispensers.push({
          FuelDispenserId: id,
          FirmwareId: firmwareId,
        });
        updateFirmwareOn(firmwareFuelDispensers);
      }
    );

    $("#update-all-filtered").on("click", function () {
      var firmwareFuelDispensers = new Array();
      $(
        "#fuel-dispensers-update-datatable .selected-datatable-row .datatable-actions .mdi-cloud-sync"
      ).each(function () {
        const id = $(this).data("fuel-dispenser-id");
        const firmwareId = $(this).data("available-update-id");
        firmwareFuelDispensers.push({
          FuelDispenserId: id,
          FirmwareId: firmwareId,
        });
        updateFirmwareOn(firmwareFuelDispensers);
      });
    });

    $("#update-firmware-button").on("click", function () {
      if (!hasValue($(".firmware-dropdown"))) {
        $("#SelectedFirmwareIdValidation").show();
      } else {
        var selectedFirmwareId = $(".firmware-dropdown").val();
        var firmwareFuelDispensers = new Array();

        var fdid = $("#update-firmware-button").data("fuel-dispenser-id");
        if (fdid.length > 1) {
          firmwareFuelDispensers.push({
            FuelDispenserId: fdid,
            FirmwareId: selectedFirmwareId,
          });
        } else {
          $(
            "#fuel-dispensers-update-datatable .selected-datatable-row .datatable-actions .mdi-cloud-sync"
          ).each(function () {
            const id = $(this).data("fuel-dispenser-id");
            firmwareFuelDispensers.push({
              FuelDispenserId: id,
              FirmwareId: selectedFirmwareId,
            });
          });
        }

        updateFirmwareOn(firmwareFuelDispensers);
      }
    });

    function hasValue($field) {
      return $field.val() ? $field.val().length !== 0 : false;
    }

    $("#select-all").on("click", function () {
      table.rows({ search: "applied" }).select();
    });

    $("#deselect-all").on("click", function () {
      table.rows().deselect();
    });

    function updateFirmwareOn(firmwareFuelDispensers) {
      const viewModel = {
        FirmwareFuelDispensersList: firmwareFuelDispensers,
      };
      $.ajax({
        url: "/FirmwareUpdates/UpdateFirmwareOn",
        method: "POST",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(viewModel),
        success: function (data) {
          $("#update-modal").modal("hide");
          if (data.success) {
            $.notificationSuccess(data.header, data.message);
            setTimeout(function () {
              document.location = "/FirmwareUpdates/Index";
            }, reloadDelay);
          } else {
            $.notificationAlert(data.header, data.message);
          }
        },
        error: function () {},
      });
    }
  };

  return {
    init: init,
  };
})();
